<template>
  <div>
    <reprocess-detail
      :breadcrumRoutes="breadcrumRoutes"
      header-title="Reproceso por Cambio"
      :reprocess-id="reprocess_id"
    />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import ReprocessDetailTemplate from '@/components/collection-and-billing/reprocesses-and-requests/reprocess/reprocess-detail-template.vue';

export default {
  name: 'ChangeAndOrAditionalDetail',
  components: {
    'reprocess-detail': ReprocessDetailTemplate
  },
  setup() {
    const breadcrumRoutes = [
      {
        breadcrumbName: 'Reprocesos / Cambio y/o adicional'
      }
    ];
    const route = useRoute();
    const reprocess_id = route.params.id;

    return {
      breadcrumRoutes,
      reprocess_id
    };
  }
};
</script>

<style></style>
